// Generated by scripts/build-ui-icons.mjs.
export { CircleNotch as default } from "../ui/glyphs-2";
